import React from 'react';
import { Table, Label } from 'reactstrap';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { pastUsedOfferShape } from 'utils/shapes';

const MobileOfferLabel = styled(Label)`
  font-weight: bold;
  margin-right: 0.5em;
`;

const StyledTable = styled(Table)`
  width: 100%;

  ${MobileOfferLabel} {
    display: none;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.small}) {
    &&& {
      tbody {
        max-height: 20rem;
      }

      thead {
        display: none;
      }

      tr {
        display: block;
        background: rgba(0, 0, 0, 0.2);
        margin: 0.2em 0;
        padding: 0.3em;
        border-radius: 0.3em;
      }

      td:first-child,
      td:last-child {
        width: 100%;
      }

      td {
        display: block;
        width: 100%;
        font-size: 0.8em;
        padding: 0;
      }

      ${MobileOfferLabel} {
        display: inline;
      }
    }
  }
`;

function PastOffers({ authenticatedNonAdmin, pastUsedOffers }) {
  return (
    <>
      {pastUsedOffers && pastUsedOffers.length > 0 && (
        <div
          className={`offers-list ${
            pastUsedOffers.length > 4 ? 'scrollable' : ''
          } ${authenticatedNonAdmin ? 'extraHeight' : ''}`}
        >
          <StyledTable size="sm" borderless>
            <thead>
              <tr>
                <th>Prize Code</th>
                <th>Prize Name</th>
                <th>Prize Dates</th>
              </tr>
            </thead>
            <tbody>
              {pastUsedOffers.map(reward => (
                <tr key={reward.rewardId}>
                  <td>
                    <MobileOfferLabel>Prize Code:</MobileOfferLabel>
                    {reward.rewardId}
                  </td>
                  <td>
                    <MobileOfferLabel>Prize Name:</MobileOfferLabel>
                    {reward.description}
                  </td>
                  <td>
                    <MobileOfferLabel>Dates Valid:</MobileOfferLabel>
                    {reward.startDateDisplay} - {reward.endDateDisplay}
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </div>
      )}
      {pastUsedOffers && pastUsedOffers.length === 0 && (
        <p>You have no past/used offers.</p>
      )}
    </>
  );
}

PastOffers.propTypes = {
  authenticatedNonAdmin: PropTypes.bool,
  pastUsedOffers: PropTypes.arrayOf(pastUsedOfferShape)
};

export default PastOffers;
